export default "__VITE_ASSET__DHCBJxb0__"